import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import AspectRatio from './AspectRatio';
import ImageBlob from './ImageBlob';

class ImageCarousel extends Component {

  state = {
    imageIndex: 0,
  };

  get currentImageDef() {
    return this.props.imageDefs[this.state.imageIndex];
  }

  render() {
    return (
      <div className={classNames("ImageCarousel", {
          "ImageCarousel--compact": this.props.compact,
          "ImageCarousel--full": !this.props.compact,
        })}
      >
        <div className={classNames("ImageCarousel__mainImageSection", {
                                    "ImageCarousel__mainImageSection--compact": this.props.compact,
                                    "ImageCarousel__mainImageSection--full": !this.props.compact,
                                  })}
        >
          <AspectRatio styleName="ImageCarousel__mainImage">
            <ImageBlob blob={this.currentImageDef.image}/>
          </AspectRatio>
          <p className="ImageCarousel__imageCredit">
            {this.currentImageDef.credit}
          </p>
        </div>
        <AspectRatio styleName={classNames({"ImageCarousel__thumbnailContainer--compact": this.props.compact,
                                            "ImageCarousel__thumbnailContainer--full": !this.props.compact,
                                          })}
        >
          {
            this.props.imageDefs.map((imageDef, index) =>
              this.renderThumbnail(imageDef.image, index, this.props.compact)
            )
          }
        </AspectRatio>
      </div>
    );
  }

  renderThumbnail(blob, index, compact) {
    return (
      <AspectRatio
        styleName={classNames({"ImageCarousel__thumbnailImage--compact": this.props.compact,
                               "ImageCarousel__thumbnailImage--full": !this.props.compact,
                              })}
        key={index}
      >
        <ImageBlob
          blob={blob}
          onClick={() => ::this.selectImage(index)}
        />
      </AspectRatio>
    );
  }

  selectImage(index) {
    this.setState({
      imageIndex: index,
    });
  }
}

ImageCarousel.propTypes = {
  imageDefs: PropTypes.array,
  compact: PropTypes.bool.isRequired,
};

export default ImageCarousel;



// WEBPACK FOOTER //
// ./src/components/ImageCarousel.js